

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import VueCookies from 'vue-cookies'
import "babel-polyfill";
Vue.use(VueCookies)

import VueI18n from 'vue-i18n'

Vue.use(VueI18n) // 通过插件的形式挂载
import md5 from 'js-md5';

let Base64 = require('js-base64').Base64;

import Calendar from 'vue2-datepicker';
Vue.use(Calendar)



const i18n = new VueI18n({

    locale: getValue("lan"),    // 语言标识  通过切换locale的值来实现语言切换,this.$i18n.locale
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-CN': require('./lang/cn'),   // 中文语言包
			'en-US': require('./lang/en'),
			'zh-TW': require('./lang/zh-TW'),
			'vi-VN': require('./lang/vi-VN'),//越南
			'ko-KR': require('./lang/ko-KR'),//韩国
			'ja': require('./lang/ja'),//日本
			'id': require('./lang/id'),//印尼
			'th': require('./lang/th'),//泰国
			'ar': require('./lang/ar'),//阿拉伯
			'sv': require('./lang/sv'),//瑞典语
			'de': require('./lang/de'),//德国
			'fr': require('./lang/fr'),//法国
			'ru': require('./lang/ru'),//俄罗斯
			'es': require('./lang/es'),//西班牙
			'pt': require('./lang/pt'),//葡萄牙
			'ms': require('./lang/ms'),//马来
			'it': require('./lang/it'),//意大利

			'mm': require('./lang/mm'),//缅甸
			'nl': require('./lang/nl'),//荷兰

			'tr': require('./lang/tr'),//土耳其
			'fi': require('./lang/fi'),//芬兰
			'uk': require('./lang/uk'),//乌克兰
			'hr': require('./lang/hr'),//克罗地亚
			'hd': require('./lang/hd'),//印地

    }
})

import Print from 'vue-print-nb'

　　Vue.use(Print);  //注册
import {post,fetch,patch,put} from './api/http'
import{needbuy,getBrowerName,getOSName,getLang,UrlDecode,getValue,setValue} from "@/utils/pub"
//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;


Vue.prototype.axios = axios
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.use(ElementUI);
Vue.prototype.getNowFormatDate = function() {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
	  month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
	  strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
  };
  //Vue.mixin() 可以把你创建的自定义方法混入所有的 Vue 实例。
Vue.mixin({
	data() {
		return {
			a:2,
			userid:getValue("userid"),
			tableCurItem: '',
			providerData: '',//供应商列表
			vpsList: '',
			svnVList: '',//svn  版本列表
			editWrap: false,
			getCronData: [],
			uplaodHeaders: {
				Authorization: getValue('token'),
	            id: getValue('id'),
			},
			// uplaodHeaders: {
			// 	Authorization: getValue('token'),
	        //     uid: getValue('uid'),
	        //     uname: getValue('loginName'),
			// },
		}
	},
	mounted:function() {

	},
	 methods: {
          getlan(name){ var str=this.$t('lang.'+name+''); if(str.indexOf("lang.")>=0){ return name; }return str },

		confirmFn(msg,ok,cancel) {
			this.$confirm( msg, "", {
		        confirmButtonText: this.getlan('ok'),
		        cancelButtonText: this.getlan('cancel'),
		        type: 'warning'
	        }).then(() => {
	        	ok();
	        }).catch(() => {
	        	if(cancel) {cancel();}
	        	else {
	        		this.$store.state.loading = false;
	        	}
	        });
		},
		alert_manual(msg) {
	        this.$this.alert_ok( msg, '提示', {
	       		confirmButtonText: this.getlan('ok'),
	        });
		},
		getDialogWidth(){
			var osname=getOSName();
			if(osname=="windows"||osname=="mac"){
				//不隐藏选择文件
				return "780px";
			}else{
				return "100%";
			}

		},
		isFullScreen(){
			var osname=getOSName();
			if(osname=="windows"||osname=="mac"){
				//不隐藏选择文件
				return false;
			}
			return true;
		},
		isHiddenFile(){


		//	this.alert_ok(browername)
		var osname=getOSName();
		if(osname=="windows"){
			//不隐藏选择文件
			return true;
		}
		var browername=getBrowerName()
			if(browername==""){
			 return false;
			}else{
				return true;
			}



		},
		alert_ok(msg) {
			this.$message({
				type: 'success',
				message: msg
			})
		},
		alert_fail(msg) {
			this.$message({
				type: 'warning',
				message: msg
			})
		},
		/* el:   id, 类, 类型, 属性
		 * text: 加载提示文字
		 * */
		Loading(el,text) {
			const loading = this.$loading({
				target: el,
				text: text||'',
				//background: 'rgba(255,255,255, .9)',
			})
			return loading;
		},
		resetSearchForm(url,searchObj) {
			this.$store.state.pageData.pSize = 10;
			this.$store.state.pageData.pNum = 1;
			this.getTabelList(url);//
	        for(var prop in searchObj) {
				var _keyVal = searchObj[prop];//对象属性的值
				if ( _keyVal instanceof Array ){
					searchObj[prop] = [];
				}else {
					searchObj[prop] = '';
				}
			}
	        console.log(searchObj)
	    },
	    // axios_Get(url,callBack) {
	    // 	this.axios.get(url, {
	    // 		headers: this.uplaodHeaders
	    // 	}).then( (res)=> {
		// 	    if(callBack) {
		// 	    	callBack(res.data);
		// 	    }else {}
		// 	})
	    // 	.catch( (res)=> {});
		// },
		axios_Get(url,callBack) {
	    	this.axios.get(url, {
	    		headers: {
		            'Authorization': getValue('token'),
		            "id" : getValue('id'),
		        }
	    	}).then( (res)=> {
			    if(callBack) {
			    	callBack(res.data);
			    }else {}
			})
	    	.catch( (res)=> {});
	    },
	    // get(url,callBack) {
	    // 	this.axios.get(url,{
	    // 		headers: this.uplaodHeaders
	    // 	}).then( (res)=> {
	    // 		var data = res.data;
	    // 		if(data.code==1) {
	    // 			if(callBack) {
	    // 				callBack(data);
	    // 			}
	    // 		}else if(data.code==4) {
	    // 			this.$router.push('/login');
	    // 		}
	    // 		else{
	    // 			this.alert_fail(data.message||data.errmsg||'内部参数错误');
	    // 		}
		// 	})
	    // 	.catch( (res)=> {});
		// },
		get(url,callBack) {
	    	this.axios.get(url,{
	    		headers: {
		            'Authorization': getValue('token'),
		            "id" : getValue('id'),
		        }
	    	}).then( (res)=> {
	    		var data = res.data;
	    		if(data.code==1) {
	    			if(callBack) {
	    				callBack(data);
	    			}
	    		}else if(data.code==4) {
	    			this.$router.push('/login');
	    		}
	    		else{
	    			this.alert_fail(data.message||'内部参数错误');
	    		}
			})
	    	.catch( (res)=> {});
	    },

	    // axios_Post(url,data,callBack,errBack) {
	    // 	this.axios.post(url, data,{
	    // 		headers: this.uplaodHeaders
	    // 	})
	    // 	.then( (res)=> {
	    // 		if(res.data=="token error") {
	    // 			this.$router.push('/login');
	    // 		}
	    // 		else if(res.data.code==4) {
	    // 			this.$router.push('/login');
	    // 		}
		// 	    if(callBack) {
		// 	    	callBack(res.data);
		// 	    }else {}
		// 	}).catch( (res)=> {
		// 		if(errBack) {
		// 			errBack(res)
		// 		}
		// 	});
		// },
		xios_post(url,data,callBack,errBack) {
	    	//axios.defaults.headers.common['Authorization'] = getValue('token');
	    	this.axios.post(url, data,{
	    		headers: {
		            'Authorization': getValue('token'),
		            "id" : getValue('id'),
		        }
	    	})
	    	.then( (res)=> {
	    		if(res.data=="token error") {
	    			this.$router.push('/login');
	    		}
	    		else if(res.data.code==4) {
	    			this.$router.push('/login');
	    		}
			    if(callBack) {
			    	callBack(res.data);
			    }else {}
			}).catch( (res)=> {
				if(errBack) {
					errBack(res)
				}

			});
	    },
		//
	    post(url,data,callBack,errBack) {
			axios.defaults.headers.common['Authorization'] = getValue('token');
			headers: this.uplaodHeaders;
	    	this.axios.post(url, data,{

				uplaodHeaders: {
		            'Authorization': getValue('token'),
		            "id": getValue('id'),
		        }
	    		// headers: this.uplaodHeaders
	    	})
	    	.then( (res)=> {
	    		var data = res.data;
	    		if(data.code==1) {
	    			if(callBack) {
	    				callBack(data);
	    			}
	    		}else if(data.code==4) {
	    			this.$router.push('/login');
	    		}
	    		else {
	    			if(errBack) {
	    				errBack(data);
	    			}else {
	    				this.alert_fail(data.message||data.errmsg||'内部参数错误');
	    			}
	    		}
			}).catch( (res)=> {});
		},

	    searchTabelList (_url,otherOjb) {
	    	this.$store.state.pageData.pNum = 1;
	    	this.$store.state.pageData.pSize = 10;

	    	var obj = {
	    		curr_page: this.$store.state.pageData.pNum,
	    		pagesize: this.$store.state.pageData.pSize
	    	}
	    	if(otherOjb) {
	    		for(var i in otherOjb) {
	    			obj[i] =  (otherOjb[i]);
	    		}
	    	}
	    	this.post(_url,Qs.stringify(obj), (res)=> {
	    		this.$store.state.loading = false;
	    		this.$store.state.pageData.tableData = res.data;
	    		this.$store.state.pageData.pSize = Number(res.pagesize);
	    		this.$store.state.pageData.total = Number(res.number);
	    	}, (res)=>{
	    		this.$store.state.loading = false;
	    	})
			},

	    //分页数据
	    getTabelList(_url,otherOjb) {
	    	this.$store.state.loading = true;
	    	var obj = {
	    		pageid: this.$store.state.pageData.pNum||1,
	    		pagesize: this.$store.state.pageData.pSize||10
	    	}
	    	if(otherOjb) {
	    		for(var i in otherOjb) {
	    			//obj[i] =  this.trim(otherOjb[i]);
	    			obj[i] =  (otherOjb[i]);
	    		}
	    	}
	    	//this.$store.state.pageData.tableData = [];
	    	this.post(_url,Qs.stringify(obj), (res)=> {
	    		this.$store.state.loading = false;
	    		this.$store.state.pageData.tableData = res.data;
	    		this.$store.state.pageData.pSize = Number(res.pagesize);
	    		this.$store.state.pageData.total = Number(res.total);
	    	}, (res)=>{
	    		this.$store.state.loading = false;
	    		this.$store.state.pageData.tableData = [];
	    	})
	    },
	    //应对一个页面2个分页数据
	    getTabelList_pageTwo(_url,otherOjb) {
	    	this.$store.state.pageData2.tableData = [];
	    	var obj = {
	    		curr_page: this.$store.state.pageData2.pNum||1,
	    		pagesize: this.$store.state.pageData2.pSize||10
	    	}
	    	if(otherOjb) {
	    		for(var i in otherOjb) {
	    			//obj[i] =  this.trim(otherOjb[i]);
	    			obj[i] =  (otherOjb[i]);
	    		}
	    	}
	    	this.post(_url,Qs.stringify(obj), (res)=> {
	    		this.$store.state.pageData2.tableData = res.data;
	    		this.$store.state.pageData2.pSize = Number(res.pagesize);
	    		this.$store.state.pageData2.total = Number(res.number);
	    	})
	    },

	    //朝伟专用
	    getTabelList3(_url,otherOjb) {
	    	this.$store.state.pageData.tableData = [];
	    	this.$store.state.loading = true;
	    	var obj = {
	    		curr_page: this.$store.state.pageData.pNum,
	    		pagesize: this.$store.state.pageData.pSize
	    	}
	    	if(otherOjb) {
	    		for(var i in otherOjb) {
	    			obj[i] = otherOjb[i];
	    		}
	    	}
	    	this.axios_Post(_url,Qs.stringify(obj), (res)=> {
	    		console.log(res.domains)
	    		this.$store.state.loading = false;
	    		this.$store.state.pageData.tableData = res.data||res.domains;
	    		this.$store.state.pageData.pSize = parseInt( res.pagesize);
	    		this.$store.state.pageData.total = res.number||res.count;
	    	})
	    },
	    //分页数据  朱工分页接口
	    getTabelList2(_url,otherOjb,callBack) {
	    	this.$store.state.pageData.tableData = [];
	    	this.$store.state.loading = true;
	    	var obj = {
	    		pageid: this.$store.state.pageData.pNum,
	    		pagesize: this.$store.state.pageData.pSize
	    	}
	    	if(otherOjb) {
	    		for(var i in otherOjb) {
	    			obj[i] = otherOjb[i];
	    		}
	    	}
	    	this.axios_Post(_url,Qs.stringify(obj), (res)=> {
	    		if(callBack) {
	    			callBack(res);
	    		}else {
		    		this.$store.state.loading = false;
		    		this.$store.state.pageData.tableData = res.Svnupdate||res.Domain||res.CDNDomain;
		    		this.$store.state.pageData.pSize = parseInt(res.pagesize)||10;
		    		this.$store.state.pageData.total = parseInt(res.total);
	    		}
	    	})
	    },
	    resetPageList(url,searchObj) {
	    	this.$store.state.pageData.pSize = 10;
	    	this.$store.state.pageData.pNum = 1;
	    	this.getTabelList(url);
	    	//清空form表单
			for(var prop in searchObj) {
				var _keyVal = searchObj[prop];//对象属性的值
				if ( _keyVal instanceof Array ){
					searchObj[prop] = [];
				}else {
					searchObj[prop] = '';
				}
			}
		},

	    //页面第二个分页重置方法
	    resetPageList_pageTwo(url,searchObj) {
	    	this.$store.state.pageData2.pSize = 10;
	    	this.$store.state.pageData2.pNum = 1;
	    	this.getTabelList_pageTwo(url);
	    	//清空form表单
			for(var prop in searchObj) {
				var _keyVal = searchObj[prop];//对象属性的值
				if ( _keyVal instanceof Array ){
					searchObj[prop] = [];
				}else {
					searchObj[prop] = '';
				}
			}
	    },
	    resetPageList2(url,searchObj) {
	    	this.$store.state.pageData.pSize = 10;
	    	this.$store.state.pageData.pNum = 1;
	    	this.getTabelList2(url);
	    	//清空form表单
			for(var prop in searchObj) {
				var _keyVal = searchObj[prop];//对象属性的值
				if ( _keyVal instanceof Array ){
					searchObj[prop] = [];
				}else {
					searchObj[prop] = '';
				}
			}
	    },
	    rowClick(row, event, column) {
		   // console.log(row)
		    this.tableCurItem = row;
		},

		//供应商接口
		getProviderList() {
			this.post(this.$store.state.url.getProList,{},(res)=> {
				this.providerData = res.data;
				getValue('providerData',JSON.stringify(res.data));
			});
		},
		//根据供应商ID获取名称
		getProviderNameById(id) {
			var roleName = '';
			var _data = JSON.parse(getValue('providerData'));
			for(var o in _data) {
				if(_data[o].id==id) {
					roleName = _data[o].name;
					break;
				}
			}
			return roleName;
		},
		//获取角色列表
		getRoleList(callBack) {
			this.post(this.$store.state.url.roleList,{},(res)=> {
				if(res.code==1000) {
					callBack(res);
					getValue('roleData',JSON.stringify(res.data));
				}
			});
		},
		getRoleNameById(id) {
			var roleName = '';
			var roleData = JSON.parse(getValue('roleData'));
			for(var o in roleData) {
				if(roleData[o].id==id) {
					roleName = roleData[o].name;
					break;
				}
			}
			return roleName;
		},
		//获取VPS城市列表
		getVpsAdressList(callBack) {
			this.post(this.$store.state.url.addressList,{},(res)=> {
				if(res.code==1000) {
					callBack(res);
				}
			});
		},
		getVpsServerList() {
			this.post(this.$store.state.url.vpsListAll,{},(res)=> {
				this.vpsList = res.data;
				getValue('vpsServerList', JSON.stringify(res.data));
			});
		},
		getVpNamesById(id) {
			var _vname = '';
			var _vAry = JSON.parse(getValue('vpsServerList'));
			for(var i=0; i<_vAry.length; i++) {
				if(_vAry[i].id==id) {
					_vname = _vAry[i].server_name;
				}
			}
			return _vname;
		},
		//机器类型列表
		getMachinetypeList () {
			this.post(this.$store.state.url.machinetypeList,{},(res)=> {
				this.$store.state.matchData = res.data;
			});
		},
		//流量类型列表
		getFlowList () {
			this.post(this.$store.state.url.flowTypeList,{},(res)=> {
				this.$store.state.flowData = res.data;
			});
		},
		//厂星级列表
		getFactorystarList () {
			this.post(this.$store.state.url.vpsstarList,{},(res)=> {
				this.$store.state.factorystarData = res.data;
			});
		},
		//获取VPS类别列表
		getVpscategoryList () {
			this.post(this.$store.state.url.vpscategoryList,{},(res)=> {
				this.$store.state.vpscategoryData = res.data;
			});
		},
		//获取环境类别
		getenviList () {
			this.post(this.$store.state.url.environmentList,{},(res)=> {
				this.$store.state.environmentData = res.data;
			});
		},
		//业务单元
		// getebusittList () {
		// 	this.post(this.$store.state.url.businessunitunitList,{},(res)=> {
		// 		this.$store.state.businessunitunitData = res.data;
		// 	});
		// },

		getebusittList () {
			this.post(this.$store.state.url.getList,{},(res)=> {
				this.$store.state.addData = res.data;
			});
		},


		//业务负责人
		getDevAndRoleList2() {
			this.post( this.$store.state.url.vpsRoleList2, {},(res)=> {
				this.$store.state.busData = res.data;
			});
		},
		//业务负责人2
		getDevAndRoleList3() {
			this.post( this.$store.state.url.vpsRoleList3, {},(res)=> {
				this.$store.state.busData2 = res.data;
			});
		},
		//同步组
		getSyncGroupList () {
			this.post(this.$store.state.url.synvGroupList,{},(res)=> {
				this.$store.state.syncGroupData = res.data;
			});
		},
		//购买账号
		getBuyAccountList() {
			this.post(this.$store.state.url.buyAccountList,{},(res)=> {
				this.$store.state.buyAccountData = res.data;
			});
		},
		//VPS 购买地点
		getLocateList() {
			this.post(this.$store.state.url.locateList,{},(res)=> {
				this.$store.state.locateData = res.data;
			});
		},
		//VPS 配置方法
		getSetting_methodList() {
			this.post(this.$store.state.url.setting_methodList,{},(res)=> {
				this.$store.state.setting_methodData = res.data;
			});
		},
		//
		getvpsRoleList() {
			this.post(this.$store.state.url.roleList2,{},(res)=> {
				this.$store.state.vpsRoleData = res.data;
			});
		},
		//获取时间管理任务列表
		getCronList () {
			this.post( this.$store.state.url.prefetch_2, {},(res)=> {
				this.getCronData = res.cron;
			});
		},
		//svn  版本列表
		svnVersionList (code) {
			this.post( this.$store.state.url.runcmd, Qs.stringify(
				{
					cmd: code,
					enctype: 'base64',

				}),(res)=> {}
			,(res)=> {
				this.svnVList = Base64.decode(res.log);
			});
		},
		//清空form 表单   （表单里的数组  单一属性 ）  data为object
		clearFormData(data) {
			for(var prop in data) {
				var _keyVal = data[prop];//对象属性的值
				if ( _keyVal instanceof Array ){
					data[prop] = [];
				}else {
					data[prop] = '';
				}
			}
		},
		//格式化时间
		formatDate(date) {
			var d = date?new Date(date):new Date();
		   	var month = '' + (d.getMonth() + 1),
		    day = '' + d.getDate(),
		    year = d.getFullYear(),
		  	h = '' +d.getHours(),
		  	m = '' +d.getMinutes(),
		  	s = '' +d.getSeconds();
		 	if (month.length < 2) month = '0' + month;
		  	if (day.length < 2) day = '0' + day;
		  	if (h.length < 2) h = '0'+h;
		  	if (m.length < 2) m = '0'+m;
		  	if (s.length<2) s = '0'+s;
		  	return year+'-'+month+'-'+day+' '+h+':'+m+':'+s;
		},
		//16进制转字符串(
		hexCharCodeToStr(hexCharCodeStr) {
		　　var trimedStr = hexCharCodeStr.trim();
		　　var rawStr =
		　　trimedStr.substr(0,2).toLowerCase() === "0x"
		　　?
		　　trimedStr.substr(2)
		　　:
		　　trimedStr;
		　　var len = rawStr.length;
		　　if(len % 2 !== 0) {
		　　　　this.alert_ok("Illegal Format ASCII Code!");
		　　　　return "";
		　　}
		　　var curCharCode;
		　　var resultStr = [];
		　　for(var i = 0; i < len;i = i + 2) {
		　　　　curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
		　　　　resultStr.push(String.fromCharCode(curCharCode));
		　　}
		　　return resultStr.join("");
		},
		trim(str){
	　　     	return str.replace(/(^\s*)|(\s*$)/g, "");
	　　 	},
		dec(s1)
  		{
		  	var tmp2='';
		    for(var i=0;i<s1.length;i++){
		        tmp2+='%'+s1.substring(i,i+=2);
		       	return decodeURIComponent(tmp2);
		   	}
		},

	}
});



/*
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})*/


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,  // 不要忘记
	router,
	store,
	render: h => h(App)
  })



// WEBPACK FOOTER //
// ./src/main.js